<template>
  <v-card>
    <v-card-title>
      {{ selectedItemLots.name }}: {{ selectedItemLots.currentStock }}
      {{ selectedItemLots.unitShortName }}
    </v-card-title>
    <v-card-text>
      <div
        class="row"
        v-for="lot in selectedItemLots.lots"
        v-bind:key="lot.stockLotId"
      >
        <div class="col">
          <v-text-field
            :disabled="true"
            v-model="lot.stockLot"
            :label="$t('LOT')"
            hide-details
            type="text"
          ></v-text-field>
        </div>
        <div class="col">
          <FormDatepickerBase
            :disabled="true"
            :type="'text'"
            :i18n="{
              label: 'LOT_EXP_DATE',
              placeholder: $t('LOT_EXP_DATE')
            }"
            :date.sync="lot.stockLotExpDate"
          ></FormDatepickerBase>
        </div>
        <div class="col">
          <v-text-field
            :disabled="true"
            v-model="lot.stockUnitValue"
            :label="$t('UNIT_VALUE')"
            hide-details
            type="number"
            step="0.01"
            min="0"
            hide-spin-buttons
            @focus="$event.target.select()"
          ></v-text-field>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="handleItemDialogClose">
        {{ $t("CLOSE") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style scoped>
tr.previewTr th {
  font-size: 18px !important;
}
</style>
<script>
import { mapGetters, mapState } from "vuex";

import FormDatepickerBase from "@/view/content/forms/components/FormDatepickerBase.vue";

import _ from "lodash";
export default {
  name: "StockAuditItemLotsPreview",
  inheritAttrs: false,
  props: {
    selectedItemLots: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  components: { FormDatepickerBase },
  beforeMount() {},
  mounted() {},

  computed: {
    ...mapGetters(["isLoadingStock", "isLoadingSharedStore", "currentUser"]),
    ...mapState({
      errors: state => state.auth.errors
    })
  },
  watch: {},
  methods: {
    handleItemDialogClose() {
      this.$emit("close");
    }
  }
};
</script>
